import React, { useState } from "react"

import { Provider } from "./src/components/context/Context"

export const wrapRootElement = ({ element }) => {
  return <Provider>{element}</Provider>
}
